// 画面のスクロール可否を制御する機能を提供する
const scrollPreventor = (prevent) => {
  if (prevent) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
};

export default scrollPreventor;
